import styled from "@emotion/styled";

function PdfReader(props) {
  return (
    <PdfContainer>
      <iframe title="pdf reader" src={props?.pdf} width="100%" height="600px" />
    </PdfContainer>
  );
}
export default PdfReader;

const PdfContainer = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
  max-width: 1200px;

  iframe {
    border: none;
    border-radius: 8px;
  }
`;
